import React from 'react'

import Y007S from './Y007-S'
import Y007M from './Y007-M'

const Y007 = (props) => {
  const { settings } = props

  switch (settings.variant) {
    case 'small':
      return <Y007S {...props} />

    case 'medium':
      return <Y007M {...props} />

    default:
      return null
  }
}

export default Y007
